import { useEffect, useState } from "react";

import { usePopover } from "@common/hooks/filtering/ui/SimplePopover";
import { FetchFNParams, useFilterHitsQuery } from "@common/hooks/filtering/useFilterHitsQuery";
import { useAppSelectionContext } from "@main/context/App/AppSelectionContext";
import { useUserFeedbackDeps } from "@main/pages/UserFeedback/UserFeedback";

interface Props {
  attributeName: string;
}

export function useBasicsItemPopover({ attributeName }: Props) {
  const { userFeedbackService } = useUserFeedbackDeps();
  const { selectedWorkspace, selectedApp } = useAppSelectionContext();

  const [query, setQuery] = useState<string>("");

  const { open, setOpen, getReferenceProps, reference, getFloatingProps, floating, x, y, strategy } = usePopover({
    placement: "bottom",
  });

  useEffect(() => {
    if (!open) (document.activeElement as HTMLElement)?.blur();
  }, [open]);

  const fetchAttributeValues = async ({ attributeName, query, deps, signal }: FetchFNParams<any[]>) => {
    const workspaceId: string = deps[0] ?? "";
    const appId: string = deps[1] ?? "";
    const open = Boolean(deps[2]);

    if (!selectedWorkspace?.id || !selectedApp?.id || !open) return [];
    return userFeedbackService
      .getUserFeedbackFiltersHits(workspaceId, appId, query ?? "", attributeName, signal)
      .then(({ data }) => data);
  };

  const { availableFilterHits, loading, error } = useFilterHitsQuery<any[]>({
    query,
    deps: [selectedWorkspace?.id, selectedApp?.id, open],
    attributeName,
    fetchFN: fetchAttributeValues,
  });

  return {
    availableFilterHits,
    open,
    setOpen,
    query,
    setQuery,
    error,
    loading,
    attributeName,
    getFloatingProps,
    floating,
    getReferenceProps,
    reference,
    x,
    y,
    strategy,
  };
}
